/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMarketPlacePoller extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMarketPlacePoller");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMarketPlacePoller.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMarketPlacePoller>): BackgroundJobPayloadForPeriodicMarketPlacePoller {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMarketPlacePoller(), model);
        BackgroundJobPayloadForPeriodicMarketPlacePoller.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMarketPlacePoller>): BackgroundJobPayloadForPeriodicMarketPlacePoller {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMarketPlacePoller.newInstance(<BackgroundJobPayloadForPeriodicMarketPlacePoller> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMarketPlacePoller) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMarketPlacePoller.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMarketPlacePoller): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMarketPlacePoller.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
